// The one sub-navigation bar for every tab that has sections: a white strip directly under the
// app header, underlined active item. Text only — no icons. Counts are optional; testId keeps existing hooks intact.
const TONES = {
  accent: { on: "border-[#007BFF] text-[#007BFF] font-semibold", off: "border-transparent text-slate-500 hover:text-slate-800 font-medium" },
  // Soft-black: BudgetBuilder (BB-UI-1) — no blue on the active or hover state.
  ink: { on: "border-[#161616] text-[#161616] dark:border-slate-100 dark:text-slate-100 font-semibold",
         off: "border-transparent text-slate-500 hover:text-[#303E41] hover:border-slate-300 dark:hover:text-slate-200 font-medium" },
};

export default function SubTabs({ tabs, active, onChange, testId, tone = "accent", divider = true }) {
  const t0 = TONES[tone] || TONES.accent;
  return (
    <div className={`shrink-0 bg-background px-4 ${divider ? "border-b border-border" : ""}`} data-testid={testId}>
      <div className="flex items-center gap-1 flex-wrap sm:flex-wrap max-sm:flex-nowrap max-sm:overflow-x-auto">
        {tabs.map((t) => {
          const on = t.active !== undefined ? t.active : active === t.key;
          return (
            <button
              key={t.key}
              type="button"
              onClick={() => onChange(t.key)}
              data-testid={t.testId || `subtab-${t.key}`}
              className={`flex items-center gap-2 whitespace-nowrap px-3 py-3 text-sm border-b-2 -mb-px transition-colors ${on ? t0.on : t0.off}`}
            >
              {t.label}
              {t.count !== undefined && t.count !== null && (
                <span className="rounded-full bg-slate-100 px-1.5 py-0.5 text-[11px] tabular-nums text-slate-600">
                  {t.count}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
